import { useState, useMemo } from "react";
import { GridPaginationModel } from "@mui/x-data-grid";

interface UseContactsPaginationProps {
  defaultPageSize?: number;
}

export const useContactsPagination = ({
  defaultPageSize = 25,
}: UseContactsPaginationProps = {}) => {
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: defaultPageSize,
  });

  const paginationState = useMemo(
    () => ({
      offset: paginationModel.page * paginationModel.pageSize,
      limit: paginationModel.pageSize,
    }),
    [paginationModel.page, paginationModel.pageSize],
  );

  const handlePaginationChange = (newModel: GridPaginationModel) => {
    setPaginationModel(newModel);
  };

  return {
    paginationModel,
    handlePaginationChange,
    paginationState,
  };
};
